import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://irionclad4.rogershep101.workers.dev';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// WebSocket connection function
export function createWebSocketConnection() {
  const wsUrl = API_BASE_URL.replace('http', 'ws');
  return new WebSocket(wsUrl);
}

export default api;
